// assets/js/layout/header.js
export function initHeaderActiveNav() {
	const page = document.body.dataset.page;
	if (!page) return;

	document.querySelectorAll('.top-bar__nav-pill a, .top-bar__nav-panel a').forEach((link) => {
		if (link.dataset.nav === page) {
			link.classList.add('is-active');
		}
	});
}

export function initHeaderCTA() {
	const cta = document.querySelector('[data-header-cta]');
	if (!cta) return;

	const page = document.body.dataset.page;

	switch (page) {
		case 'inicio':
		case 'cuestionarios':
			cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Regístrate gratis</a>
			`;
			break;

		case 'planes':
			cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Regístrate gratis</a>
			`;
			break;
		case 'info':
			cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Regístrate gratis</a>
			`;
			break;

		case 'app':
			cta.innerHTML = `
				<!-- 🔐 AUTH BAR (renderizada por AuthHeaderController + AuthHeaderView) -->
				<div class="auth-bar" data-auth-header></div>
			`;
			break;

		default:
			cta.innerHTML = `
				<a class="btn btn-primary" href="app.html">[...to be configured]</a>
			`;
	}
}
